import React, { useState } from "react";
import GcStudentMasterLayout from "../../../layouts/gcstudent/GcStudentMasterLayout";
import LibraryPage from "../../../subsreens/gcstudent/librarypage/LibraryPage";
import AboutDigiLib from "../../../components/gcstudent/aboutsection/HeroSection";

const GcLibrary = () => {
    const LibraryData = { title: 'Library', highLight: 'Books', subTitle: 'Browse our physical book collection. Reserve books and pick them up from the library.' };

    const [selectedBook, setSelectedBook] = useState(null);

    return <>
        <GcStudentMasterLayout>
            {!selectedBook && <AboutDigiLib heroData={LibraryData} />}
            <LibraryPage selectedBook={selectedBook} setSelectedBook={setSelectedBook} />
        </GcStudentMasterLayout>
    </>
}

export default GcLibrary;